import { Link } from 'wouter';

import { Wordmark } from './Icons';
import { Button } from './Primitives';

interface HeaderProps {
  variant?: 'marketing' | 'app';
  ctaLabel?: string;
}

export function Header({ variant = 'app', ctaLabel = 'Make a free poll' }: HeaderProps) {
  return (
    <header className="wf-header">
      <Link href="/" className="logo" aria-label="WhomFree home">
        <Wordmark height={28} />
      </Link>
      <nav>
        <Link href="/me" className="btn btn-text btn-sm">
          My polls
        </Link>
        <Link href="/new">
          <Button size="sm" variant="primary">
            {variant === 'marketing' ? `${ctaLabel} →` : '+ New poll'}
          </Button>
        </Link>
      </nav>
    </header>
  );
}
